import { useFormContext } from '../../components/Form'

export const useFormCanSubmit = (ignoreDirty = false) => {
  const { dirty, isSubmitting, isValid } = useFormContext()
  return isValid && !isSubmitting && (dirty || ignoreDirty)
}
